import { dataFullscreen } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFullscreen = /*#__PURE__*/createIcon(dataFullscreen)
export default IconFullscreen
